import axios from 'axios';
import store from '@/store/store'
import router from './router'



// 创建axios实例
var instance = axios.create();

instance.defaults.headers.post['Content-Type'] = 'application/json;charSet=UTF-8'

instance.defaults.headers.get['Content-Type'] = 'application/json;charSet=UTF-8'

instance.defaults.headers.put['Content-Type'] = 'application/json;charSet=UTF-8'

instance.defaults.headers.delete['Content-Type'] = 'application/json;charSet=UTF-8'

instance.defaults.headers.patch['Content-Type'] = 'application/json;charSet=UTF-8'

// instance.defaults.timeout = 50000;
instance.defaults.withCredentials = true

instance.interceptors.request.use(
    
    config => {
        config.headers.common['sysTime'] = Date.parse(new Date())

        return config;
    },

    error => {
        console.log('请求失败！！' + error)
        return Promise.reject(error)

    })

//异步请求后，判断token是否过期
instance.interceptors.response.use(
    response => {
        // console.log('响应拦截器：response：', response);
        if (response.data.statusCode === 500) {
            if (response.data.message === '请先登录') {
                router.push({
                    path: '/',
                    query: { redirect: router.history.current.fullPath }
                })
                //如果需要可以在这里将 vuex 里的 user 改为空对象
            }
            //显示错误信息
            return Promise.reject(response)
        }
        if (response.status === 200) {
            if (response.data.statusCode === "701") {
                router.replace({
                    path: '/',
                    query: { redirect: router.currentRoute.fullPath }//登录成功后跳入浏览的当前页面
                })
                store.commit("del_token");
            }
            return response;
        }

        if (response.data.statusCode === "200") {
            return response;
        }
        // 数据异常
        if (response.data.statusCode === 4000) {
            console.log("data+:" + response.data);
            return response;
        }
    },
    error => {

        if (error.response) {
            switch (error.response.status) {
                case 401:
                    this.$store.commit('del_token');
                    router.replace({
                        path: '/',
                        query: { redirect: router.currentRoute.fullPath }//登录成功后跳入浏览的当前页面
                    })
                    break
            }
        }
        return Promise.reject(error.response)
    }
)

setInterval(async () => {
    console.log("check login.....")
    try {
      const res = await axios.post('/apis/system/currentUser', {}, {
        withCredentials: true,
        headers: { 'sysTime': Date.now() }
      });
      if (res.data.statusCode !== '200') {
        store.commit('del_token');
        store.commit('checkLogin', false);
        const msg = res.data.message || '登录已过期';
        window.location.replace('/?reason=' + encodeURIComponent(msg));

      }
    } catch (e) {
      // 网络异常忽略，不踢人
    }
  }, 2*60*1000);
export default instance;


// WEBPACK FOOTER //
// ./src/http.js